<template>
  <div class="ti d-flex">
    <div class="d-flex-left">
      <erp-tree-status @node-click="nodeClick"></erp-tree-status>
    </div>
    <div class="d-flex-right">
      <div>
        <el-form size="mini" :inline="true" label-width="80px" class="demo-form-inline">
          <el-form-item label="房产">
            <el-input :value="home_name" style="width: 400px" disabled></el-input>
            <search-house @change="home_id=$event.value,home_name=$event.label" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-popover
              placement="bottom"
              trigger="hover">
              <template slot="default">
                <h3>说明</h3>
                <p>1.此处只作为显示所用，不做具体操作修改，如需要修改请管家端进行绑定，客户管理处进行具体修改。</p>
                <p>2.以下二维码，未绑定的企业微信普通“扫一扫”扫码后，请自行在通过应用页面内的扫描按钮在进行扫一次对应的码，选择对应的房产，进行绑定。</p>
                <p>3.以下二维码，已绑定的管家端页面“一户一码”扫码后，自行进入该业主（户主）的相关页面。</p>
              </template>
              <el-button icon="el-icon-info" circle slot="reference"></el-button>
            </el-popover>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-refresh" circle @click="initUser"></el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 100%;overflow-x: scroll">
        <HouseCodeTable ref="HouseCodeTable" @onTable="onTable" @edtiClik="edtiClik" @outClik="outClik" :where="formInline" :id="home_id"/>
      </div>
    </div>


  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import ErpTreeStatus from "../Common/erp-tree-status";
import SearchHouse from "../Common/search-house";
import HouseCodeTable from "./HouseCodeTable";
export default {
  name: "HouseCodeList",
  components: {
    HouseCodeTable,
    SearchHouse,
    ErpTreeStatus,
    ErpTree
  },
  data(){
    return{
      activeName:'1',
      home_id:0,
      home_name:"",
      formInline:{
        name:""
      },
      activeCollapseName:''
    }
  },
  methods:{
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.home_name=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.home_id=data.tree[data.tree.length-1].id;
        this.formInline={}
      }else {
        this.home_id=0;
        this.formInline.name=tree_str;
        this.onSubmit();
      }
    },
    onSubmit(){
      console.log(this.formInline)
      var that=this;
      that.$refs.HouseCodeTable.getData(that.home_id||0,1)
    },
    outClik(status){
      status&&this.$refs.CustomerRentTable.getData(this.home_id)
      status&&this.$refs.CustomerRentLog.getData(this.home_id)
    },
    onTable(e){
      this.home_id=e.data.house_id;
      this.home_name=e.data.address;
      console.log(e);
    },
    onForm(e){
      if(e){
        this.$refs.CustomerRentTable.getData(this.home_id)
      }
      this.openWinStatus=false;
    },
    edtiClik(e){
      console.log(e)
    },
    billPrintClick(furnish_id){
      var that=this;
      if(!furnish_id){
        that.$alert("没选中装修编号")
      }
      furnish_id&&that.$refs.PrintFurnish.getData({
        home_id:that.home_id,
        furnish_id,
        success(ret){
          console.log(ret)
          that.printJS()
        },
        error:e=>{
          that.$alert("打印异常")
        }
      })

    },
    initUser(){
      ERP.showLoading()
      ERP.getRequest({url:"admin/HouseCode/initUser",data:{}},ret=>{
        if(ret.code){
          console.log(ret.data);
        }else{
          this.$msgbox.alert(ret.msg||"查询失败")
        }
        ERP.hideLoading()
      },err=>{
        ERP.hideLoading()
        this.$msgbox.alert(JSON.stringify(err))
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/HouseCodeList.vue